export const FUNPOST_DESCRIPTION =
  "ポストが楽しくなる FunPost\r\n\r\nポストに入っているチラシを、LINEで受け取る＆見るだけでポイントがもらえるサービスです！\r\n\r\nポイントが貯まってポストをスッキリさせて、紙を減らしてデカボ（脱炭素）に貢献しましょう。";
